function FastRewindIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className="icon-fast-rewind" viewBox="0 0 24 24" {...props}>
      <path
        d="M22 5a1 1 0 00-1.5-.86l-12 7a1 1 0 000 1.72l12 7A1 1 0 0022 19V5z"
        className="secondary"
      />
      <path
        d="M15 5a1 1 0 00-1.5-.86l-12 7a1 1 0 000 1.72l12 7A1 1 0 0015 19V5z"
        className="primary"
      />
    </svg>
  );
}

export default FastRewindIcon;
